import _ from 'lodash';
import {DocumentNumberId} from '../constants/IDVerificationConstants.js';
import {Constants} from '../constants/WorkItemConstants';
import FilenoteTriggers from './WorkItemFilenoteTriggers';
import {ProductIds, ClientIdentificationModes} from '../constants/ApplicationConstants.js';
import {YesNoValues} from '../constants/ApplicationConstants.js';
import Products from '../utils/Products.js';
import DateTime from '../utils/DateTime.js';
import ApplicationHelper from './ApplicationHelper.js';

const workItemPlaceHolderTemplate = '__BACKFILE__PLACEHOLDER__{{id}}';

function generateFileNote(fileTitle, workItemObject) {
    const workItem = workItemObject.file,
    isBackFile = workItemObject.isBackFile;
    // 1. Pull data from scenario triggers
    let htmlDataString = '',
        errors = [],
        cssClassHideWorkItem = ' workItem__hidden', // always add space because this is added to className
        cssClassSectionHeader = 'confirm-section-header',
        divWrapper = '<div class="container">',
        divWrapperClose = '</div>';

    _.each(workItem, (o) => {
        // 1. Format body
        let item = '', body = '';

        if(isBackFile) {
            // 2. Construct HTML - header, section(s), instructions
            item = '<div class="backFile-header backFile workItem">';
        }else {
            // 2. Construct HTML - header, section(s), instructions
            item = '<div class="fileNote-header fileNote workItem">';
        }

        if (o.title) {
            item += generateHeader(o.title);
        }

        if (o.htmlConstruct) {
            body += o.htmlConstruct;
        }
        if (o.containers) {
            _.each(o.containers, (idName) => {
                let containerId = document.getElementById(idName);
                if (containerId) {

                    if (o.title && o.hideSectionHeader) {
                        const sectionHeader = containerId.getElementsByClassName(cssClassSectionHeader);
                        if (sectionHeader && sectionHeader.length > 0) {
                            sectionHeader[0].className += cssClassHideWorkItem;
                        }
                    }

                    let componentHtml = containerId.innerHTML;
                    if (o.replacePlaceHolder) {
                        let elementToBeReplaced = document.getElementById(o.replacePlaceHolder);
                        if (elementToBeReplaced) {
                            let toBeReplaced = document.getElementById(o.replacePlaceHolder).innerHTML;
                            if (toBeReplaced) {
                                let placeHolder = workItemPlaceHolderTemplate.replace('{{id}}', o.replacePlaceHolder);
                                componentHtml = componentHtml.replace(toBeReplaced, placeHolder);
                            }
                        }
                    }
                    body += componentHtml;
                }
            });
        }
        if (o.querySelectorAll && o.querySelectorLabels && o.querySelectorLabels.length > 0) {
            _.each(document.querySelectorAll(o.querySelectorAll), (element) => {
                if (o.includeSelector && element.querySelector(o.includeSelector)) {
                    body += element.innerHTML;
                }
                _.each(o.querySelectorLabels, (label) => {
                    let span = element.querySelector('span');
                    if (span && span.innerHTML === label) {

                        let elementHtml = o.outerSelector ? element.outerHTML : element.innerHTML;
                        if (o.replacePlaceHolder) {
                            let elementToBeReplaced = document.getElementById(o.replacePlaceHolder);
                            if (elementToBeReplaced) {
                                let toBeReplaced = document.getElementById(o.replacePlaceHolder).innerHTML;
                                if (toBeReplaced) {
                                    let placeHolder = workItemPlaceHolderTemplate.replace('{{id}}', o.replacePlaceHolder);
                                    elementHtml = elementHtml.replace(toBeReplaced, placeHolder);
                                }
                            }
                        }
                        body += elementHtml;
                    }
                });
            });
        }

        if (body) {
            item += (o.wrap ? divWrapper : '') + body + (o.wrap ? divWrapperClose : '');

            if (o.instructions) {
                item += generateInstructions(o.instructions);
            }

            item += divWrapperClose;
            htmlDataString += item;
        } else {
            errors.push({
                id: o.id,
                IS_UNDEFINED: true
            });
        }
    });

    let html = '';

    if(isBackFile) {
        html = '<div class="backFile-border"><div class="backFile-title"><h2>' + fileTitle + '</h2></div>' + htmlDataString + '</div>';
    }else {
        html = '<div><div class="container"><div class="row"><div class="col-xs-12"><h2>' + fileTitle + '</h2></div></div><div class="row"><div class="col-xs-3"><strong>Name</strong></div><div class="col-xs-3">' + Constants.FilenoteName + '</div><div class="col-xs-3"><strong>OIN</strong></div><div class="col-xs-3">' + Constants.FilenoteOin + '</div></div><div class="row"><div class="col-xs-3"><strong>Product</strong></div><div class="col-xs-3">' + Constants.FilenoteProduct + '</div><div class="col-xs-3"><strong>Account Number</strong></div><div class="col-xs-3">' + Constants.FilenoteAccountNumber + '</div></div><div class="row"><div class="col-xs-3"><strong>Date of Application</strong></div><div class="col-xs-3">' + Constants.FilenoteDateOfApp + '</div><div class="col-xs-3"><strong>'+ Constants.FilenoteDateOfBirthField + '</strong></div><div class="col-xs-3">' + Constants.FilenoteDateOfBirth + '</div></div></div>' + htmlDataString + '</div>';
    }

    // 3. Send html constructs via API service
    return {
        errors: errors,
        data: html
    };
}

function generateInstructions(instructions) {
    if (!instructions) {
        return '';
    }
    return ('<div class="container"><div class="workItem__instructions">'
        + '<h5>Instructions</h5>'
        + instructions + '</div></div>');
}

function generateHeader(title) {
    if (!title) {
        return '';
    }
    return '<div class="container"><div class="row confirm-section-header"><div class="col-xs-10"><h4>' + title + '</h4><span class="confirm-section-header__message"></span></div></div></div>';
}

function generateRow(label, value) {
    if (!label || !value) {
        return '';
    }

    return ('<div class="row simple-review-row"><div class="col-xs-4"><span>' + label +
            '</span></div><div class="col-xs-8"><span class="simple-review-value">' + value
            + '</span></div></div>');
}

function generateMessage(message) {
    if (!message) {
        return '';
    }
    return ('<div class="row simple-review-row"><div class="col-xs-12"><span>' + message + '</span></div></div>');
}

function getUpdatedFormModel(formModel, workItem) {
    let formModelFormWorkItem = _.cloneDeep(formModel.form.workItem);

    if (!_.isUndefined(workItem.fileNote)) {
        _.assign(formModelFormWorkItem, { fileNote: workItem.fileNote });
    }

    if (!_.isUndefined(workItem.confirmDetailsBackFile)){
        _.assign(formModelFormWorkItem, { confirmDetailsBackFile: workItem.confirmDetailsBackFile });
    }

    if (!_.isUndefined(workItem.idVerificationBackFile)) {
        _.assign(formModelFormWorkItem, { idVerificationBackFile: workItem.idVerificationBackFile });
    }

    return formModelFormWorkItem;
}

function getIdVerificationBackFile(investorList) {
    const investors = _.cloneDeep(investorList);
    let backFileItems = [];

    let investorAccountNumber = '<div class="container">';
    investorAccountNumber += generateRow('Investor account no:', Constants.BackfileCustomerAccountNumber);
    investorAccountNumber += '</div>';

    backFileItems.push({
        id: 'BACKFILE_IDVERIFICATION_INVESTORACCTNO',
        htmlConstruct:  investorAccountNumber
    })

    _.each(investors, investor => {
        let investorSection = '';
        const commSeeKycVerifiedDate = _.get(investor, 'commSeeKycVerifiedDate', null);
        
        if (commSeeKycVerifiedDate !== null) {
            investorSection += '<div class="container">';
            const clientCif = _.get(investor, 'cif', '');
            investorSection += generateRow('CommSee Customer Identification Facility (CID) ID:', clientCif);
            const verifiedDate = new Date(commSeeKycVerifiedDate);
            investorSection += generateRow('KYC verification date:', DateTime.dateToString(verifiedDate));
            investorSection += '</div>';
        } else {
            let verificationDocuments = _.get(investor, 'verificationDocuments', []);
            _.each(verificationDocuments,
                doc => {
                    investorSection += '<div class="container">';
                    investorSection += generateMessage('Document type');
                    investorSection += generateMessage(doc.typeDescription);
                    investorSection += '</div>';
                    investorSection += '<div class="container">';
                    _.each(doc.meta,
                        docInput => {
                            if (docInput.id === DocumentNumberId) {
                                investorSection += generateRow(docInput.label + ':', workItemPlaceHolderTemplate.replace('{{id}}', doc.id));
                            } else {
                                investorSection += generateRow(docInput.label + ':', docInput.value);
                            }
                        });
                    investorSection += '</div>';
                });
        }
        
        backFileItems.push({
            id: 'BACKFILE_IDVERIFICATION_INVESTOR_' + investor.investorId,
            title: '<u>For ' + investor.fullName + '</u>',
            htmlConstruct: investorSection
        });
    });

    let adviserDetails = '<div class="container">';
    adviserDetails += generateRow('Adviser name:', Constants.BackfileAdviser);
    adviserDetails += generateRow('FMS Dealer ID', Constants.BackfileDealerId);
    adviserDetails += generateRow('FMS Adviser ID', Constants.BackfileAdviserId);
    adviserDetails += generateRow('Date verification completed:', Constants.BackfileAdviserDateVerification);
    adviserDetails += '</div>';

    backFileItems.push({
        id: 'BACKFILE_IDVERIFICATION_ADVISER_DETAILS',
        title: '<u>Adviser details</u>',
        htmlConstruct: adviserDetails
    });

    const backFile = generateFileNote('Identification and verification details', {
        file: backFileItems,
        isBackFile: true
    });

    return backFile;
}

function getCommSeeBackFile(clientIdentificationMode, formModel) {
    const isEformBackFileExist = clientIdentificationMode.identificationMode === ClientIdentificationModes.E_FORM;
    const commSeeKycVerifiedDate = _.get(clientIdentificationMode, 'commSeeKycVerifiedDate', null);
    const isCfpAdvised = ApplicationHelper.isCfpAdvised(formModel);
    
    if (!isEformBackFileExist && isCfpAdvised && commSeeKycVerifiedDate !== null) {
        const clientCif = ApplicationHelper.getClientCif(formModel);
        const clientFullName = formModel.form.yourDetails.givenName + ' ' + formModel.form.yourDetails.lastName;
        const investorList = [{investorId: 0, fullName: clientFullName, cif:clientCif, commSeeKycVerifiedDate: commSeeKycVerifiedDate}]
        const commSeeBackFile = WorkItemHelper.getIdVerificationBackFile(investorList);
        return commSeeBackFile;
    }

    return null;
}

function fillWorkItemPlaceHolder(placeHolderValues, workItemFile) {
    if (placeHolderValues && workItemFile) {
        _.forEach(placeHolderValues,
        function(placeHolderValue) {
            const key = placeHolderValue.documentId;
            const value = placeHolderValue.placeHolderValue;
            const placeHolder = workItemPlaceHolderTemplate.replace('{{id}}', key);
            workItemFile = workItemFile.replace(placeHolder, value);
        });
    }

    return workItemFile;
}

function generateBackFileToSubmit(workItemPlaceHolders, workItem, hasDigitalSignature) {
    const confirmDetailsErrors = workItem && workItem.confirmDetailsBackFile && workItem.confirmDetailsBackFile.errors ?
        workItem.confirmDetailsBackFile.errors : [];
    const idVerificationErrors = workItem && workItem.idVerificationBackFile && workItem.idVerificationBackFile.errors ?
        workItem.idVerificationBackFile.errors : [];
    const errors = confirmDetailsErrors.concat(idVerificationErrors);

    const confirmDetailsData = workItem && workItem.confirmDetailsBackFile && workItem.confirmDetailsBackFile.data ?
        workItem.confirmDetailsBackFile.data : '';
    const idVerificationData = workItem && workItem.idVerificationBackFile && workItem.idVerificationBackFile.data ?
        workItem.idVerificationBackFile.data : '';
    const digitalConsentData = workItem && workItem.digitalConsentBackFile && workItem.digitalConsentBackFile.data ?
        workItem.digitalConsentBackFile.data : '';

    const workItemData = (hasDigitalSignature && hasDigitalSignature === YesNoValues.YES) ? confirmDetailsData + idVerificationData + digitalConsentData : idVerificationData;

    const data = fillWorkItemPlaceHolder(workItemPlaceHolders, workItemData);

    const backFile = { data: data, errors: errors };
    return backFile;
}


function generateFileNoteToSubmit(workItemPlaceHolders, workItem, hasDigitalSignature) {

    const errors = workItem && workItem.fileNote && workItem.fileNote.errors ?
        workItem.fileNote.errors : [];

    const fileNoteData = workItem && workItem.fileNote && workItem.fileNote.data ?
        workItem.fileNote.data : '';

    const data = (hasDigitalSignature && hasDigitalSignature === YesNoValues.YES) ? fillWorkItemPlaceHolder(workItemPlaceHolders, fileNoteData) : '';

    const fileNote = { data: data, errors: errors };
    return fileNote;
}

function extractFilenote(data, productId, content) {
    let fileNote = [];
    const isPension = Products.isPension(productId),
        isInvestment = Products.isInvestment(productId),
        isSuper = Products.isSuper(productId),
        dateToday = new Date();

    if (isSuper) {
        fileNote = fileNote.concat(FilenoteTriggers.internalRollover(data, content));
        // these are removed for r47.1 as FMS already handles these scenarios
        //fileNote = fileNote.concat(FilenoteTriggers.onlineAccess(data, content));
        //fileNote = fileNote.concat(FilenoteTriggers.clientProvidedTfn(data, content));
        fileNote = fileNote.concat(FilenoteTriggers.personalContributionDirectDebit(data, content));
        fileNote = fileNote.concat(FilenoteTriggers.termDepositInvestAllocation(data, content));
        // removed for r48 as FMS already handles this scenario
        //fileNote = fileNote.concat(FilenoteTriggers.adviserFee(data, content));
        fileNote = fileNote.concat(FilenoteTriggers.ripThirdPartyBankDetails(data, content));
        fileNote = fileNote.concat(FilenoteTriggers.employmentStatus(data, content, dateToday, ProductIds.SUPER));
    }

    if (isPension) {
        fileNote = fileNote.concat(FilenoteTriggers.internalRollover(data, content));
        fileNote = fileNote.concat(FilenoteTriggers.specialRequest(data, content));
        fileNote = fileNote.concat(FilenoteTriggers.personalContributionDirectDebit(data, content));
        // removed for r48 as FMS already handles this scenario
        //fileNote = fileNote.concat(FilenoteTriggers.pensionType(data, content));
        //fileNote = fileNote.concat(FilenoteTriggers.adviserFee(data, content));
        fileNote = fileNote.concat(FilenoteTriggers.pensionPayment(data, content));
        fileNote = fileNote.concat(FilenoteTriggers.superFirstTransferSelected(data, content));
        fileNote = fileNote.concat(FilenoteTriggers.ripThirdPartyBankDetails(data, content));
        fileNote = fileNote.concat(FilenoteTriggers.inSpecieSelection(data, content));
        fileNote = fileNote.concat(FilenoteTriggers.employmentStatus(data, content, dateToday, ProductIds.PENSION));
    }

    if (isInvestment) {
        fileNote = fileNote.concat(FilenoteTriggers.internalRollover(data, content));
        // this is removed for r47.1 as FMS already handles this scenario
        //fileNote = fileNote.concat(FilenoteTriggers.onlineAccess(data, content));
        fileNote = fileNote.concat(FilenoteTriggers.personalContributionDirectDebit(data, content));
        fileNote = fileNote.concat(FilenoteTriggers.taxResidence(data, content));
        fileNote = fileNote.concat(FilenoteTriggers.manualAddress(data, content));
        fileNote = fileNote.concat(FilenoteTriggers.termDepositInvestAllocation(data, content));
        fileNote = fileNote.concat(FilenoteTriggers.jointAccountType(data, content));
        // removed for r48 as FMS already handles this scenario
        //fileNote = fileNote.concat(FilenoteTriggers.adviserFee(data, content));
        fileNote = fileNote.concat(FilenoteTriggers.soleTraderAccountType(data, content));
        fileNote = fileNote.concat(FilenoteTriggers.ripThirdPartyBankDetails(data, content));
        fileNote = fileNote.concat(FilenoteTriggers.incomeDistributionNonFunding(data, content));
        fileNote = fileNote.concat(FilenoteTriggers.fundingInvestment(data, content));
    }
    if (fileNote.length > 0) {
        return generateFileNote('Document Type: Call to action',
        {
            file: fileNote
        });
    } else {
        return null;
    }
}

function checkIsWorkitemRequired(application, productId) {
    if (!application) return null;

    let kycFlag = true;

    const isPension = Products.isPension(productId),
        isInvestment = Products.isInvestment(productId),
        isSuper = Products.isSuper(productId);

    if (application.form.yourDetails.investorList.length > 0) {
        _.each(application.form.yourDetails.investorList, investor => {
            kycFlag = kycFlag && investor.kycFlag;
        });
    } else if (application.form.yourDetails.trusteeList.length > 0) {
        _.each(application.form.yourDetails.trusteeList, trustee => {
            kycFlag = kycFlag && trustee.kycFlag;
        });
    } else {
        kycFlag = application.form.yourDetails.kycFlag;
    }

    return (isSuper || (isInvestment || isPension) && kycFlag);
}

const WorkItemHelper = {
    generateFileNote: generateFileNote,
    generateInstructions: generateInstructions,
    generateHeader: generateHeader,
    generateRow: generateRow,
    generateMessage: generateMessage,
    getUpdatedFormModel: getUpdatedFormModel,
    getIdVerificationBackFile: getIdVerificationBackFile,
    getCommSeeBackFile: getCommSeeBackFile,
    generateBackFileToSubmit: generateBackFileToSubmit,
    generateFileNoteToSubmit: generateFileNoteToSubmit,
    extractFilenote: extractFilenote,
    checkIsWorkitemRequired: checkIsWorkitemRequired
};

export default WorkItemHelper;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/WorkItemHelper.js